import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const visions = ['Sabiendo exactamente cuánto ganás.', 'Entendiendo dónde se va tu dinero.', 'Tomando mejores decisiones.', 'Con más control financiero.', 'Con menos estrés.', 'Y con una estrategia clara para crecer.'];
export function VisionSection() {
  return <section className="py-14 md:py-20 bg-primary relative overflow-hidden" data-id="element-320">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10 mix-blend-overlay" data-id="element-321" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-gradient-to-b from-white/10 to-transparent pointer-events-none" data-id="element-322" />

      <div className="container mx-auto px-5 md:px-6 relative z-10" data-id="element-323">
        <div className="max-w-4xl mx-auto bg-background/95 backdrop-blur-md rounded-3xl md:rounded-[3rem] p-6 md:p-12 border border-white/10 shadow-2xl" data-id="element-324">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-6 md:mb-10" data-id="element-325">
            <h2 className="text-2xl sm:text-3xl md:text-5xl text-white" data-id="element-326">
              IMAGINÁ TU NEGOCIO DENTRO DE{' '}
              <span className="text-primary italic" data-id="element-327">30 DÍAS</span>
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-5" data-id="element-328">
            {visions.map((vision, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="flex items-center gap-3 p-3 rounded-xl bg-surface/30 border border-surface-light/50" data-id="element-329">
                <CheckCircle2Icon className="w-5 h-5 md:w-6 md:h-6 text-primary flex-shrink-0" data-id="element-330" />
                <span className="text-sm md:text-lg text-text font-medium leading-snug" data-id="element-331">
                  {vision}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}